import React from 'react';
import ReactDOM from 'react-dom/client';
import './lib/authFetch'; // 로그인 토큰을 API 요청에 자동으로 붙임 (App 보다 먼저)
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
